export default "__VITE_ASSET__19d19dfb__"